{
  "acquisitionDate": "Acquisition Date",
  "analysisName": "Analysis Name",
  "batch": "Batch",
  "batchSize": "Batch Size",
  "checkinUser": "Check in User",
  "createdAt": "Created At",
  "createdBy": "Created by",
  "currentStep": "Current Step",
  "currentStepLogsLoadError": "Failed to open the logs for the current step.",
  "directDiaSettings": "Direct DIA Settings",
  "errorMessage": "An error occurred: {{error}}",
  "fasta": "Fasta File",
  "failedBatchLogsArchivedLogCaveat": "Archived logs only exist for pods that failed at the Kubernetes level. If no archived log exists, the log viewer will report that the audited storage log was not found.",
  "failedBatchLogsLoadError": "Failed to load failed batch logs.",
  "failedBatchLogsTitle": "Failed batch logs",
  "fileLocation": "Item location",
  "fileName": "Item name",
  "fileSizeInGiB": "Size (in GiB)",
  "finishedAt": "Finished at: {{time}}",
  "finishedAtNoTime": "Finished At",
  "gxp": "GXP",
  "instrumentCode": "Instrument Code",
  "libraryPulsarSettings": "Library (Pulsar) Settings",
  "locationType": "Type",
  "loadingFailedBatchLogs": "Loading failed batches...",
  "logs": "Analysis Logs",
  "newJobCreated": "New job successfully created",
  "noBatchFoundForCurrentStepLogs": "No batch found for the current step logs.",
  "noFailedBatchLogsResolved": "Failures were reported for this job, but no failed or aborted batch could be resolved.",
  "omicsFlow": "OmicsFlow",
  "oidcSignIn": "OIDC Sign In",
  "password": "Password",
  "pipeline": "Pipeline",
  "priority": "Priority",
  "collapseSidebar": "Collapse OmicsFlow sidebar",
  "expandSidebar": "Expand OmicsFlow sidebar",
  "progress": "Progress",
  "projectId": "Project ID",
  "projectName": "Project Name",
  "projectNumber": "Project Number",
  "quoteNumber": "Quote Number",
  "reportSettings": "Report Settings",
  "runTimeInMin": "Total runtime (in minutes)",
  "select": "Select {{item}}",
  "showCurrentStepLogs": "Show logs for the current step",
  "software": "Software",
  "softwareVersion": "Software Version",
  "softwareSettings": "Software Settings",
  "startedAt": "Started At",
  "status": "Status",
  "submit": "Submit",
  "task": "Task",
  "username": "Username",
  "required": "{{field}} is required",
  "maxLength": "Max {{max}} characters",
  "invalidProjectNameFormat": "Only letters, numbers, '-', '_' and '.' are allowed; no spaces; must start and end with a letter or number; max 63 chars.",
  "jobCreationFailed": "Job creation failed.",
  "fileCount": "Item Count",
  "actions": "Actions",
  "doubleClickForDetails": "Double click for details"
}
